import { render, staticRenderFns } from "./myplan.vue?vue&type=template&id=205e2ea4&scoped=true&"
import script from "./myplan.vue?vue&type=script&lang=js&"
export * from "./myplan.vue?vue&type=script&lang=js&"
import style0 from "./myplan.vue?vue&type=style&index=0&id=205e2ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e2ea4",
  null
  
)

export default component.exports